module.exports = __webpack_public_path__ + "media/images/cc-bdea858a23fe0a5113888d24c084f5ed.webp";